<div class="container-fluid">
  <form #monitorPipelineForm="ngForm" (ngSubmit)="getMonitorPipelineList(monitorPipelineForm);">
    <div class="row">
      <div class="col-md-6 col-lg-6">
        <div class="row">
          <div class="col-md-5 col-lg-5">
            <input placeholder="Start Date Time"
                   class="form-control wd85"
                   required name="StartTime"
                   [(ngModel)]="StartTime"
                   [owlDateTime]="dt"
                   [readonly]="true">
            <span class="pointer trigger date_icon" [owlDateTimeTrigger]="dt">
              <mat-icon>date_range</mat-icon>
            </span>
            <owl-date-time #dt></owl-date-time>
          </div>
          <div class="col-md-5 col-lg-5">
            <input placeholder="End Date Time"
                   class="form-control wd85"
                   required name="EndTime"
                   [(ngModel)]="EndTime"
                   [owlDateTime]="dt1"
                   [readonly]="true">
            <span class="pointer trigger date_icon" [owlDateTimeTrigger]="dt1">
              <mat-icon>date_range</mat-icon>
            </span>
            <owl-date-time #dt1></owl-date-time>
          </div>
          <div class="col-md-2 col-lg-2">
            <button class="btn searchBtn" [disabled]="!monitorPipelineForm.valid">SEARCH</button>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-6"></div>
    </div>

  </form>
  <div class="example-container pm-10" detect-scroll>
    <div class="fixed-height">
      <mat-table #monitorPipelineTable #monitorPipelineTableSort="matSort" [dataSource]="monitorPipelineList" matSort matSortActive="runStart" matSortDirection="desc"
                 (scroll)="onTableScroll($event)">

        <ng-container matColumnDef="pipelineName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="Header TitleMatParameterName">
            <mat-form-field class="filter" floatLabel="never">
              <span><input matInput [formControl]="pipelineNameFilter" placeholder="Pipeline Name"></span>
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatParameterName">{{row.pipelineName}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="runStart">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="Header TitleMatParameterName">
            <span class="col-head-span">Run Start</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatParameterName">{{row.runStart}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="duration">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="Header TitleMatDuration">
            <span class="col-head-span">Duration</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatDuration">{{row.durationInMs | date:'HH:mm:ss'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="Header TitleMatStatus">
            <mat-form-field class="filter" floatLabel="never">
              <span><input matInput [formControl]="statusFilter" placeholder="Status"></span>
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="TitleMatStatus">
            <ng-container *ngIf="row.status == 'Succeeded'">
              <mat-icon class="green-icon">check_circle</mat-icon><span class="icon-text-align">{{row.status}}</span>
            </ng-container>
            <ng-container *ngIf="row.status == 'Failed'">
              <mat-icon class="red-icon">cancel</mat-icon><span class="icon-text-align">{{row.status}}</span>
            </ng-container>
            <ng-container *ngIf="row.status == 'InProgress'">
              <mat-icon>rotate_right</mat-icon><span class="icon-text-align">{{row.status}}</span>
            </ng-container>
            <ng-container *ngIf="row.status == 'Queued'">
              <mat-icon>query_builder</mat-icon><span class="icon-text-align">{{row.status}}</span>
            </ng-container>
            <ng-container *ngIf="row.status == 'Cancelled'">
              <mat-icon class="red-icon">cancel</mat-icon><span class="icon-text-align">{{row.status}}</span>
            </ng-container>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="parameters">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="Header ClsMatEquipment">
            <span class="col-head-span">Parameters</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="ClsMatEquipment wb">
            <a title="Parameters" class="pointer pl-15" (click)="viewParameterDilog(row.parameters)"><mat-icon>visibility</mat-icon></a>
          </mat-cell>


        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>
    </div>
  </div>
  </div>
